<div class="card">
	<div class="card-header">
		<h1>Retenciones automáticas</h1>
	</div>
	<div class="card-body">
		<div>
			<h5>Archivo a cargar</h5>
			<div class="input-group">
				<input type="file" (change)="onFileSelected($event)" name="file" id="file" class="form-control">
			</div>
		</div>
		<app-loading-button [object]="upload" [disabled]="!selectedFile" (clicked)="uploadRegisters()"></app-loading-button>
	</div>
</div>